import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { setUpErrorHandling } from '@bingads-webui-campaign/summary-grid-helper';
import { getColumnsConversionMap } from '@bingads-webui-campaign/column-conversions';

import { DimensionGrid } from './dimension-grid-view';
import { getConfig } from './grid-config';
import { getBaseDimensionPlugins } from './plugins';

const i18n = globalContext.require('$/i18n!global');

export function createDimensionGrid({
  filterService,
  getAdditionalPlugins,
  preferenceConfig,
  scope,
  addDateChangeListener,
  p$daterange,
  isForVNext = false,
  viewport,
  perfMarker,
  customHeaderOffset,
  columns,
  gridType,
  entitySet,
  startDate,
  endDate,
  columnChooserConfig,
  reportName,
  customDataSource = null,
  reportSchema,
  preferenceService,
  appConfig,
}) {
  const gridName = `${gridType}Grid`;
  const columnConversionGridName = 'DimensionsGrid';
  const permissions = appConfig.get('Permissions');
  return new DimensionGrid({
    isForVNext,
    filterService,
    getGridConfig: view => getConfig({
      gridName,
      entitySet,
      startDate,
      endDate,
      columns,
      isForVNext,
      view,
      viewport,
      customHeaderOffset,
      reportName,
      customDataSource,
      filterService,
      appConfig,
    }),
    getPlugins: view => getBaseDimensionPlugins({
      gridName,
      isForVNext,
      addDateChangeListener,
      p$daterange,
      columnChooserConfig,
      perfMarker,
      reportSchema,
      preferenceService,
      columnConversions: getColumnsConversionMap(columnConversionGridName, permissions),
    }).concat(getAdditionalPlugins(view)),
    setupDataSourceErrorHandling: view => setUpErrorHandling({
      gridView: view,
      scope,
      dataSource: view.dataSource,
      i18n,
    }),
    preferenceConfig,
    gridType,
  }).render();
}
